import _regeneratorRuntime from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import router from './router';
import { store } from '@/store/index';
import getPageTitle from '@/utils/page';
var asyncRouterFlag = 0;
var whiteList = ['login', 'init', 'emailConfirm'];
router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(to, from, next) {
    var token, needModifyPwd, asyncRouters;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          token = store.getters['user/token'];
          needModifyPwd = store.getters['user/needModifyPwd']; // 重置密码
          if (!(token && needModifyPwd && to.name != 'modifyPwd')) {
            _context.next = 5;
            break;
          }
          next({
            name: 'modifyPwd'
          });
          return _context.abrupt("return");
        case 5:
          // 在白名单中的判断情况
          //修改网页标签名称
          document.title = getPageTitle(to.meta.title);
          if (!(whiteList.indexOf(to.name) > -1)) {
            _context.next = 10;
            break;
          }
          if (to.name == 'emailConfirm' || !token) {
            next();
          } else {
            next({
              name: store.getters["user/userInfo"].authority.defaultRouter
            });
          }
          _context.next = 22;
          break;
        case 10:
          if (!token) {
            _context.next = 21;
            break;
          }
          if (!(!asyncRouterFlag && store.getters['router/asyncRouters'].length == 0)) {
            _context.next = 20;
            break;
          }
          asyncRouterFlag++;
          _context.next = 15;
          return store.dispatch('router/SetAsyncRouter');
        case 15:
          asyncRouters = store.getters['router/asyncRouters'];
          router.addRoutes(asyncRouters);
          next(_objectSpread(_objectSpread({}, to), {}, {
            replace: true
          }));
          _context.next = 21;
          break;
        case 20:
          next();
        case 21:
          // 不在白名单中并且未登陆的时候
          if (!token) {
            next({
              name: "login",
              query: {
                redirect: document.location.hash
              }
            });
          }
        case 22:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());